import React, { useEffect, useLayoutEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useAdminReviewDetail, useAdminReviewResultDetail, useAdminReviewReviewee } from "../../../../api/admin/review/hooks";
import styled from "styled-components";
import ReviewResult from "../../../organisms/ReviewResult";
import RevieweeList from "../../../organisms/RevieweeList";
import { useState } from "react";

/**
 * 리뷰 결과 상세
 * - 관리자자용 화면
 */
const ReviewResultDetail = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const scrollRef = useRef(null);
    const pathname = useLocation().pathname;
    let splitPathname = pathname.split("/");
    const reviewIdx = splitPathname[splitPathname.length - 1];

    const [activeRevieweeIdx, setActiveRevieweeIdx] = useState();
    const [activeReviewee, setActiveReviewee] = useState();
    const { data: reviewResultData, isLoading: isReviewResultDetailLoading, refetch } = useAdminReviewResultDetail(reviewIdx, activeRevieweeIdx);
    const { data: reviewData, isLoading: isReviewDetailLoading, reviewDetailRefetch } = useAdminReviewDetail(reviewIdx);
    const { data: revieweeList, isLoading: isRevieweeLoading, refetch: revieweeListRefetch } = useAdminReviewReviewee(reviewIdx);

    // Reviewee 목록 중 첫 번째 아이템이 기본 선택 되도록 처리
    useEffect(() => {
        setActiveRevieweeIdx(revieweeList?.data?.[0]?.user?.reviewee_idx)
    }, [revieweeList, setActiveRevieweeIdx]);

    // 선택한 리뷰이가 바뀌면(activeRevieweeIdx 변경) reviewResultData 를 refetch 하여 뷰에 반영
    useEffect(() => {
        if (activeRevieweeIdx) {
            refetch()
            // 리뷰이 데이터도 추출 (ReviewResult에 전달하여 캡쳐 파일명에 활용하기 위함)
            const curReviewee = revieweeList?.data?.find(
                item => item.user.reviewee_idx === activeRevieweeIdx
            )
            setActiveReviewee(curReviewee)
        }
    }, [activeRevieweeIdx, refetch])

    // activeRevieweeIdx 가 바뀌면 리뷰폼을 최상단으로 스크롤
    useEffect(() => {
        const node = scrollRef.current
        if (!node) return

        requestAnimationFrame(() => {
            const scrollContainer = getScrollParent(node)
                if (scrollContainer === window) {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
            } else {
                scrollContainer.scrollTo({ top: 0, left: 0, behavior: "smooth" })
            }
        })
    }, [activeRevieweeIdx])

    useEffect(() => {
        if (reviewResultData?.data) {
            console.log("@@ReviewResultData:", reviewResultData?.data);
        }
    }, [reviewResultData]);

    useEffect(() => {
        if (revieweeList?.data) {
            console.log("@@revieweeList:", revieweeList?.data);
        }
    }, [revieweeList]);

    useEffect(() => {
        console.log("@@activeRevieweeIdx", activeRevieweeIdx);
    }, [activeRevieweeIdx]);

    // 스크롤 가능한 조상 뷰를 찾아 주는 헬퍼
    function getScrollParent(el) {
        if (!el) return window
        const style = window.getComputedStyle(el)
        const overflowY = style.overflowY
        if (overflowY === "auto" || overflowY === "scroll") return el
        return getScrollParent(el.parentElement)
    }

    return (
        <>
            {reviewResultData && (
                <>
                    <Wrap>
                        <RevieweeList 
                            idx={reviewIdx} 
                            revieweeList={revieweeList} 
                            activeRevieweeIdx={activeRevieweeIdx} 
                            setActiveReviewee={setActiveRevieweeIdx} 
                            reviewAnswerData={[]}
                            setReviewAnswerData={() => {}}
                            reviewAnswerDefaultData={[]}
                            revieweeListRefetch={() => revieweeListRefetch()}
                            isRevieweeSelectable={"0"}
                            >
                        </RevieweeList>

                        <div className="review-form" ref={scrollRef}>
                            <ReviewResult reviewDetailData={reviewData?.data} reviewResultData={reviewResultData?.data} activeReviewee={activeReviewee} />
                        </div>
                    </Wrap>
                </>
            )}
        </>
    );
};

const Wrap = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 50px;

    .review-form {
        display: flex;
        flex-direction: column;
        width: 800px;
    }
`;

export default ReviewResultDetail;